<template>
    <div class="transaction-info">
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                id ордера:
            </span>
            <span class="transaction-info__item-value">
                <RouterLink
                    v-if="orderId"
                    :to="{ name: 'order', params: { id: orderId } }"
                >
                    {{ orderId }}
                </RouterLink>
                <template v-else>
                    -
                </template>
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                id в системе:
            </span>
            <span class="transaction-info__item-value">
                {{ id }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Валюта:
            </span>
            <span class="transaction-info__item-value transaction-info__item-value--currency">
                <CurrencyImg
                    class="transaction-info__currency-img"
                    :currency="currencyTo"
                />
                {{ currencyTo }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Сумма:
            </span>
            <span class="transaction-info__item-value">
                {{ amountTo }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Адрес пополнения:
            </span>
            <span class="transaction-info__item-value">
                {{ addressTo }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Тег адреса пополнения:
            </span>
            <span class="transaction-info__item-value">
                {{ tagTo }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Адрес отправки:
            </span>
            <span class="transaction-info__item-value">
                {{ addressFrom }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Тег адреса отправки:
            </span>
            <span class="transaction-info__item-value">
                {{ tagFrom }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                id в блокчейне:
            </span>
            <span class="transaction-info__item-value">
                {{ txId }}
            </span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Ссылка на транзакцию:
            </span>
            <span class="transaction-info__item-value"></span>
        </div>
        <div class="transaction-info__item">
            <span class="transaction-info__item-title">
                Дата создания:
            </span>
            <span class="transaction-info__item-value">
                {{ createdAt }}
            </span>
        </div>
    </div>
</template>

<script>

import Moment from "moment";
import { mapGetters } from 'vuex';

import CurrencyImg from "/public/components/elements/CurrencyImg";

export default {
    name: 'DepositTransactionInfo',
    components: {
        CurrencyImg,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters('app', [
            'getCurrencyNameById',
        ]),
        orderId () {
            return this.data.orderId || '-';
        },
        id () {
            return this.data.id;
        },
        currencyTo () {
            const {
                data: { currencyTo },
                getCurrencyNameById,
            } = this;

            return getCurrencyNameById(currencyTo);
        },
        addressTo () {
            return this.data.addressTo;
        },
        tagTo () {
            return this.data.tagTo || '-';
        },
        amountTo () {
            return this.data.amountTo;
        },
        addressFrom () {
            return this.data.addressFrom;
        },
        tagFrom () {
            return this.data.tagFrom || '-';
        },
        txId () {
            return this.data.txId || '-';
        },
        createdAt () {
            return Moment(Number(this.data.createdAt)).format('DD.MM.YYYY, HH:mm');
        },
    },
};

</script>